<template>
  <div class="img">
    <van-image
      :src="
        itemData.imageUrl + '?x-oss-process=image/resize,w_750/quality,q_80'
      "
    ></van-image>
  </div>
</template>

<script>
export default {
  props: {
    itemData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      imgSrc: "",
    };
  },
  methods: {
    changeImg(e) {
      this.imgSrc = e.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .van-image {
    width: 100%;
    height: 100%;
    display: block;
    text-align: center;
  }
}
</style>
